import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-banner.tsx
var LazyBanner = lazy(() => import("./banner-BC8aUYiT.js").then((n) => n.n).then((module) => ({ default: module.Banner })));
function Banner({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "banner" }),
		children: /* @__PURE__ */ jsx(LazyBanner, { ...props })
	});
}
function BannerContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "banner" }),
		children: /* @__PURE__ */ jsx(LazyBanner, { ...props })
	});
}
var useBannerContent = () => {
	return useMemo(() => ({ hero: { component: BannerContent } }), []);
};
//#endregion
export { Banner, useBannerContent };
